import { render, staticRenderFns } from "./amend-password.vue?vue&type=template&id=b7ead480&scoped=true&"
import script from "./amend-password.vue?vue&type=script&lang=js&"
export * from "./amend-password.vue?vue&type=script&lang=js&"
import style0 from "./amend-password.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./amend-password.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./amend-password.vue?vue&type=style&index=2&id=b7ead480&lang=scss&scoped=true&"
import style3 from "./amend-password.vue?vue&type=style&index=3&id=b7ead480&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ead480",
  null
  
)

export default component.exports